import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import { ETC } from "./components/Paths/d/etc"
import { FA } from "./components/Paths/d/fa"
import { IBZA } from "./components/Paths/d/ibza"
import { IBZW } from "./components/Paths/d/ibzw"
import { RN } from "./components/Paths/d/rn"
import { W } from "./components/Paths/d/w"

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/d/etc',
      element: <ETC />
  },
    {
        path: '/d/rn',
        element: <RN />
    },
    {
        path: '/d/fa',
        element: <FA />
    },
    {
        path: '/d/ibza',
        element: <IBZA />
    },

    {
        path: '/d/ibzw',
        element: <IBZW />
    },
    {
        path: '/d/w',
        element: <W />
    },

];

export default AppRoutes;
